import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  item: css`
    border-bottom: 1px solid ${colors.silver};
  `,
  card: css`
    display: flex;
    align-items: center;
    padding: 16px;
    gap: 12px;
  `,
  cardButton: css`
    display: flex;
    flex: 1;
    align-items: center;
    min-width: 0;
    cursor: pointer;
  `,
  cardContentInactive: css`
    cursor: default;
  `,
  avatarWrapper: css`
    position: relative;
    flex-shrink: 0;
    margin-right: 16px;
  `,
  avatar: css`
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Montserrat Bold', Arial, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 700;
    color: ${colors.prussian};
  `,
  avatarInactive: css`
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Montserrat Bold', Arial, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 700;
    background-color: ${colors.mercury};
    color: ${colors.neutralAsh};
  `,
  followButton: css`
    gap: 8px !important;
  `,
  activeDot: css`
    position: absolute;
    top: 5%;
    left: 2px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${colors.leaf};
  `,
  info: css`
    flex: 1;
    min-width: 0;
  `,
  orgName: css`
    margin: 0 0 2px;
    text-transform: capitalize;
  `,
  location: css`
    color: ${colors.slate};
    margin: 0 0 4px;
  `,
};

export default styles;
